import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import SelectView from './SelectView';
import Rodal from 'rodal';
import { SkillProjectButton } from './SkillSetting';
import { PC, Mobile } from '../ Responsive';
import Slider from 'react-slick';

import 'rodal/lib/rodal.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const Container = styled.div`
    display: flex;
    align-items: center;
    overflow-x: auto;
    white-space: nowrap;
    height: 100vh;
    width: 100vw;
    position: relative; /* 부모 컨테이너의 position을 relative로 설정 */
`;

const LeftButtonContainer = styled.div`
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

    display: flex;
    justify-content: space-between;
    padding: 10px;
    box-sizing: border-box;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.3s;

    &:hover {
        opacity: 1; /* 호버 시 보이도록 */
    }
`;
const RightButtonContainer = styled.div`
    position: fixed;
    top: 11.6%;
    transform: translateY(-50%);
    z-index: 2;

    display: flex;
    justify-content: space-between;
    padding: 10px;
    box-sizing: border-box;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.3s;

    &:hover {
        opacity: 1; /* 호버 시 보이도록 */
    }
`;

const ButtonStyle = styled.div`
    background-color: rgba(0, 0, 0, 30%);
    height: ${window.innerHeight / 1.3}px;
    width: ${window.innerWidth / 12}px;
    border-radius: 30px 0 0 30px;
    align-items: center;
    display: flex;
    justify-content: center;

    color: white;
`;

const ImageContainer = styled.div`
    width: ${window.innerWidth / 6.5}px;
`;
const ImageWebContainer = styled.div`
    width: ${window.innerWidth / 5}px;
`;

const SliderContainer = styled.div`
    display: flex;
`;

const ImageSlider = styled.img`
    border-radius: 10px;
`;
const TitleContainer = styled.div`
    border-radius: 10px;

    width: 35%;
    font-weight: 200;
    font-size: medium;
    text-align: center;
    color: black;
    border: 1px solid black;
`;
const TitleText = styled.div`
    font-weight: 700;
    font-size: x-large;
`;

const ImageSliderWeb = styled.img`
    width: 200px;
    height: 200px;
`;

const TextParagraph = styled.div`
    overflow: hidden;
    white-space: normal;

    width: 80%;
`;

const SkillTitle = styled.div`
    font-weight: 600;
    margin-top: 10px;
`;
const SkillContent = styled.div`
    font-weight: 300;
    margin-left: 2%;
    font-size: small;
`;

function Project() {
    const [scrollX, setScrollX] = useState(0);
    const [scrollY, setScrollY] = useState(0);
    const [visable, setVisable] = useState(false);
    const [contentNum, setContentNum] = useState(null);
    const [hoveredButton, setHoveredButton] = useState(false); // 호버된 버튼 인덱스

    const handleMouseEnter = (index) => {
        // 마우스가 버튼 위에 올라갔을 때 실행되는 함수
        setHoveredButton(index);
    };

    const handleMouseLeave = () => {
        // 마우스가 버튼에서 벗어났을 때 실행되는 함수
        setHoveredButton(false);
    };

    const containerRef = useRef(null);

    // 컨테이너의 스크롤 위치가 변경될 때마다 스크롤 위치를 업데이트
    const handleScroll = () => {
        if (containerRef.current) {
            setScrollX(containerRef.current.scrollLeft);
        }
    };

    useEffect(() => {
        // 스크롤 이벤트 리스너 추가
        if (containerRef.current) {
            containerRef.current.addEventListener('scroll', handleScroll);
        }

        return () => {
            // 컴포넌트 언마운트 시 이벤트 리스너 제거
            if (containerRef.current) {
                containerRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (visable) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [visable]);

    // 왼쪽 버튼 클릭 시 스크롤 위치를 0으로 이동
    const handleLeftButtonClick = () => {
        if (containerRef.current) {
            containerRef.current.scrollTo({ left: 0, behavior: 'smooth' });
        }
    };

    // 오른쪽 버튼 클릭 시 스크롤 위치를 최대로 이동
    const handleRightButtonClick = () => {
        if (containerRef.current) {
            const maxScrollLeft = containerRef.current.scrollWidth - containerRef.current.clientWidth;
            containerRef.current.scrollTo({ left: maxScrollLeft, behavior: 'smooth' });
        }
    };

    const settings = {
        dots: true,
        lazyLoad: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
    };

    return (
        <Container ref={containerRef}>
            <div style={{ display: scrollY == window.innerHeight * 2 ? 'flex' : 'none' }}>
                <LeftButtonContainer>
                    <ButtonStyle onClick={handleLeftButtonClick}>←</ButtonStyle>
                </LeftButtonContainer>
                <RightButtonContainer>
                    <ButtonStyle
                        onClick={handleRightButtonClick}
                        style={{
                            position: 'absolute',
                            left: `${window.innerWidth / 1.1}px`,
                            borderRadius: '0 30px 30px 0',
                        }}
                    >
                        →
                    </ButtonStyle>
                </RightButtonContainer>
            </div>
            <PC>
                {' '}
                <Rodal
                    visible={visable}
                    animation="slideUp"
                    onClose={() => setVisable(false)}
                    leaveAnimation="slideRight"
                    width={window.innerWidth * 0.78}
                    height={window.innerHeight * 0.9}
                >
                    {contentNum === 0 && (
                        <div>
                            <SliderContainer>
                                <ImageContainer>
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            <ImageSlider src={'images/todoMypetFeed1.gif'} />
                                            <ImageSlider src={'images/todoMypetFeed2.gif'} />
                                            <ImageSlider src={'images/todoMypetFeed4.gif'} />
                                            <ImageSlider src={'images/todoMypetFeed3.gif'} />
                                            <ImageSlider src={'images/todoMypetFeed6.gif'} />
                                            <ImageSlider src={'images/todoMypetFeed5.gif'} />
                                        </Slider>
                                    </div>
                                    <div
                                        style={{
                                            marginTop: '15%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <SliderContainer style={{ marginBottom: 20 }}>
                                            <TitleContainer>GITHUB</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <div>
                                                <a href="https://github.com/baebang/TodoMyPet_FE" target="_blank">
                                                    투두마이펫 깃허브 🐈‍⬛
                                                </a>
                                            </div>
                                        </SliderContainer>

                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer>STACK</TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="React-Native" colorset={'#61DAFB'} />
                                            <SkillProjectButton content="React-Query" colorset={'#FF4154'} />
                                        </SliderContainer>
                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer style={{ color: 'white', border: '0px' }}>
                                                STACK
                                            </TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="Zustand" colorset={'#ED9A01'} />
                                            <SkillProjectButton content="Axios" colorset={'#4F25E0'} />
                                        </SliderContainer>
                                        <SliderContainer style={{ marginTop: 15 }}>
                                            <TitleContainer>LINK</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <a
                                                href="https://apps.apple.com/kr/app/todomypet/id6479068243"
                                                target="_blank"
                                            >
                                                🍎 AppStore
                                            </a>
                                        </SliderContainer>
                                    </div>
                                    <SliderContainer style={{ bottom: 0 }}>
                                        <TitleContainer style={{ color: 'white', border: '0px' }}>STACK</TitleContainer>
                                        <div style={{ width: '10px' }} />

                                        <a
                                            href="https://m.onestore.co.kr/mobilepoc/apps/appsDetail.omp?prodId=0000775420"
                                            target="_blank"
                                        >
                                            🤖 Onestore
                                        </a>
                                    </SliderContainer>
                                </ImageContainer>
                                <div
                                    style={{
                                        marginLeft: '4%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <div>
                                        <TitleText>프로젝트 이름</TitleText>
                                        <div>내 손안의 귀여운 일정 도우미, 투두마이펫</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 기간</TitleText>
                                        <div>2023.09 - 2024.03</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 소개</TitleText>
                                        <TextParagraph>
                                            투두리스트와 함께 성장하는 나만의 펫을 키울 수 있습니다. 오늘의 할 일을
                                            달성하면 펫이 자라나고, 펫의 이름도 직접 지을 수 있습니다. 꾸준한 출석으로도
                                            경험치를 얻을 수 있죠. 투두리스트, 스케줄, 루틴을 한 곳에서 관리할 수
                                            있으며, 원하는 일정만 캘린더에 표시할 수 있습니다. 또한 친구를 추가하고
                                            피드로 소통하며, 오늘 하루를 귀엽고 알차게 리뷰할 수 있습니다. 펫 도감을
                                            모으고 다양한 업적을 달성하는 재미도 있으며, 중요한 할 일과 일정은 알림으로
                                            설정할 수 있습니다.
                                        </TextParagraph>
                                    </div>
                                    <div>
                                        <TitleText>참여 인원</TitleText>
                                        <div>프론트엔드 1인 / 백엔드 1인 / 디자이너 1인</div>
                                    </div>
                                    <TitleText>구현기능</TitleText>
                                    <div style={{ overflowY: 'scroll', maxHeight: '300px' }}>
                                        <SkillTitle>- 투두리스트 및 스케줄 관리</SkillTitle>
                                        <SkillContent>
                                            : 사용자 중심 설계를 기반으로 한 직관적인 투두리스트 기능 개발
                                        </SkillContent>
                                        <SkillContent>
                                            : 재사용 가능한 공통 컴포넌트 개발 (Button, Dropdown, Modal 등)
                                        </SkillContent>
                                        <SkillContent>: 사용자 맞춤형 일정 조회를 위한 선택적 캘린더 기능</SkillContent>
                                        <SkillContent>: 다양한 색상 테마를 통한 사용자 경험 개선</SkillContent>
                                        <SkillTitle>- 펫 성장 및 관리</SkillTitle>
                                        <SkillContent>: 사용자 행동 데이터 기반의 지속적 성장 시스템 설계</SkillContent>
                                        <SkillContent>
                                            : 다양한 업적 달성을 통한 펫 성장 유도 메커니즘 도입
                                        </SkillContent>
                                        <SkillContent>: 사용자 개인화를 위한 펫 이름 지정 기능 구현</SkillContent>
                                        <SkillContent>: 수집형 펫 도감 기능 구현을 통한 사용자 동기 부여</SkillContent>
                                        <SkillContent>: 다양한 업적 달성 시스템 설계 및 시각화</SkillContent>
                                        <SkillTitle>- 사용자 간 소통 기능</SkillTitle>
                                        <SkillContent>: 직관적인 소셜 네트워크 기능 개발</SkillContent>
                                        <SkillContent>
                                            : 인피니트 스크롤링과 레이지 로딩을 통한 유연한 사용자 경험 제공
                                        </SkillContent>

                                        <SkillTitle>- 알림 및 알람 기능</SkillTitle>
                                        <SkillContent>: Firebase 연동을 통한 실시간 알림 기능 제공</SkillContent>
                                        <SkillContent>: 멀티 채널(푸시, 이메일 등) 알림 시스템 구축</SkillContent>
                                    </div>
                                </div>
                            </SliderContainer>
                        </div>
                    )}
                    {contentNum === 1 && (
                        <div>
                            <SliderContainer>
                                <ImageWebContainer>
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            <ImageSlider src={'images/FairyTeller1.png'} />
                                            <ImageSlider src={'images/FairyTeller2.png'} />
                                            <ImageSlider src={'images/FairyTeller3.png'} />
                                            <ImageSlider src={'images/FairyTeller4.png'} />
                                            <ImageSlider src={'images/FairyTeller5.png'} />
                                            <ImageSlider src={'images/FairyTeller6.png'} />
                                            <ImageSlider src={'images/FairyTeller7.png'} />
                                            <ImageSlider src={'images/FairyTeller8.png'} />
                                        </Slider>
                                    </div>
                                    <div className="slider-container" style={{ marginTop: 29 }}>
                                        <Slider {...settings}>
                                            <ImageSlider src={'images/Fairy-Teller_1.gif'} />
                                            <ImageSlider src={'images/Fairy-Teller_2.gif'} />
                                            <ImageSlider src={'images/Fairy-Teller_3.gif'} />
                                        </Slider>
                                    </div>
                                    <div
                                        style={{
                                            marginTop: '15%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <SliderContainer style={{ marginBottom: 20 }}>
                                            <TitleContainer>GITHUB</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <div>
                                                <a
                                                    href="https://github.com/Fairy-Teller/FairyTeller_FE"
                                                    target="_blank"
                                                >
                                                    페어리텔러 깃허브 🐈‍⬛
                                                </a>
                                            </div>
                                        </SliderContainer>

                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer>STACK</TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="React" colorset={'#61DAFB'} />
                                            <SkillProjectButton content="Recoile" colorset={'#2D6DE1'} />
                                            <SkillProjectButton content="Style-Component" colorset={'#DDA2DB'} />
                                        </SliderContainer>
                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer style={{ color: 'white', border: '0px' }}>
                                                STACK
                                            </TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="Fabric.js" colorset={'#1E99D9'} />
                                            <SkillProjectButton content="Axios" colorset={'#4F25E0'} />
                                        </SliderContainer>

                                        <SliderContainer style={{ marginTop: 15 }}>
                                            <TitleContainer>LINK</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <a
                                                href="https://drive.google.com/file/d/1SyOzfaN81Rm9ycCAGfiC0tIhEqOO3Pf7/view?usp=sharing&t=79"
                                                target="_blank"
                                            >
                                                전체 시연영상 🔗
                                            </a>
                                        </SliderContainer>
                                    </div>
                                </ImageWebContainer>
                                <div
                                    style={{
                                        marginLeft: '4%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-evenly',

                                        height: window.innerHeight * 0.86,
                                    }}
                                >
                                    <div>
                                        <TitleText>프로젝트 이름</TitleText>
                                        <div>AI 동화 만들기, 페어리텔러</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 기간</TitleText>
                                        <div>2023.06 - 2023.07</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 소개</TitleText>
                                        <TextParagraph>
                                            키워드를 선택해 이야기를 자동으로 만들거나 사용자가 자신의 동화 시나리오를
                                            작성하면, AI가 그에 어울리는 이미지를 생성합니다. 이러한 이미지들은 캔버스에
                                            담겨 사용자만의 독특한 동화책으로 완성됩니다. 이 동화책은 기존의 동화책과는
                                            다르게, Text to Image 기술을 활용하여 전문적인 기술이나 역량 없이도 누구나
                                            동화를 제작할 수 있습니다. 사용자가 만든 동화는 게시판을 통해 가족이나
                                            친구들과 공유하여 더 자유로운 창작 활동을 이끌어 낼 수 있습니다.
                                        </TextParagraph>
                                    </div>
                                    <div>
                                        <TitleText>참여 인원</TitleText>
                                        <div>프론트엔드 2인 / 백엔드 3인</div>
                                    </div>
                                    <TitleText>구현기능</TitleText>
                                    <div style={{ overflowY: 'scroll', maxHeight: '300px' }}>
                                        <SkillTitle>- Fabric.js를 활용한 캔버스 기능 구현</SkillTitle>
                                        <SkillContent>
                                            : 캔버스 상태를 JSON 형태로 저장하고 로드할 수 있는 기능 개발
                                        </SkillContent>
                                        <SkillContent>
                                            : Fabric.js의 기본 기능을 확장하여 undo/redo 기능 구현 (캔버스 객체 변경
                                            이력을 스택 구조로 관리)
                                        </SkillContent>

                                        <SkillTitle>- 임시저장 기능 구현</SkillTitle>
                                        <SkillContent>
                                            : 브라우저의 localStorage를 활용하여 작업 내용을 임시 저장
                                        </SkillContent>
                                        <SkillContent>
                                            : 자동 저장 기능을 통해 사용자의 작업 내용을 주기적으로 저장
                                        </SkillContent>

                                        <SkillContent>
                                            : 저장된 데이터를 불러와 작업을 이어갈 수 있도록 사용자 편의 개선
                                        </SkillContent>

                                        <SkillTitle>- TTS 음성 녹음 기능 및 송출 기능</SkillTitle>
                                        <SkillContent>
                                            : Web Audio API의 MediaRecorder 인터페이스를 사용하여 사용자의 음성을 녹음
                                        </SkillContent>

                                        <SkillTitle>- 동화 export 기능 및 동화 보기 페이지 구현</SkillTitle>
                                        <SkillContent>
                                            : 캔버스 상의 콘텐츠를 이미지 또는 PDF 형태로 export
                                        </SkillContent>
                                        <SkillContent>
                                            : 반응형 웹 디자인을 적용하여 다양한 디바이스에서 동화를 볼 수 있도록 구현
                                        </SkillContent>
                                    </div>
                                </div>
                            </SliderContainer>
                        </div>
                    )}
                    {contentNum === 2 && (
                        <div>
                            <SliderContainer>
                                <ImageWebContainer>
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            <ImageSlider src={'images/dajabaPic1.png'} />
                                            <ImageSlider src={'images/dajabaPic2.png'} />
                                            <ImageSlider src={'images/dajabaPic3.png'} />
                                            <ImageSlider src={'images/dajabaPic4.png'} />
                                        </Slider>
                                    </div>
                                    <div className="slider-container" style={{ marginTop: 29 }}>
                                        <Slider {...settings}>
                                            <ImageSlider src={'images/Dajaba1.gif'} />
                                            <ImageSlider src={'images/Dajaba2.gif'} />
                                            <ImageSlider src={'images/Dajaba3.gif'} />
                                        </Slider>
                                    </div>
                                    <div
                                        style={{
                                            marginTop: '15%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <SliderContainer style={{ marginBottom: 20 }}>
                                            <TitleContainer>GITHUB</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <div>
                                                <a href="https://github.com/baebang/DajabA" target="_blank">
                                                    다잡아 깃허브 🐈‍⬛
                                                </a>
                                            </div>
                                        </SliderContainer>

                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer>STACK</TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="React" colorset={'#61DAFB'} />
                                            <SkillProjectButton content="Recoile" colorset={'#2D6DE1'} />
                                            <SkillProjectButton content="Webgazer.JS" colorset={'#000000'} />
                                        </SliderContainer>
                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer style={{ color: 'white', border: '0px' }}>
                                                STACK
                                            </TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="Firebase" colorset={'#FFC52A'} />
                                            <SkillProjectButton content="Netlify" colorset={'#33E6E2'} />
                                        </SliderContainer>

                                        <SliderContainer style={{ marginTop: 15 }}>
                                            <TitleContainer>LINK</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <a
                                                href="https://drive.google.com/file/d/1MUxtIYb33VFzN_kMWWVMsYSsuQTXwBeV/view?usp=sharing"
                                                target="_blank"
                                            >
                                                전체 시연영상 🔗
                                            </a>
                                        </SliderContainer>
                                    </div>
                                </ImageWebContainer>
                                <div
                                    style={{
                                        marginLeft: '4%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-evenly',

                                        height: window.innerHeight * 0.86,
                                    }}
                                >
                                    <div>
                                        <TitleText>프로젝트 이름</TitleText>
                                        <div>면접 시선 교정 서비스, 다잡아</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 기간</TitleText>
                                        <div>2022.03 - 2022.06</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 소개</TitleText>
                                        <TextParagraph>
                                            프로젝트의 핵심 서비스는 면접이나 중요한 상황에서 사용자의 시선 집중도를
                                            측정하고 분석하는 것입니다. 이를 통해 사용자가 중요한 정보에 집중하는 정도를
                                            파악하고, 시선 처리에 관련된 문제를 개선할 수 있습니다. 이러한 분석은
                                            사용자가 면접이나 핵심 업무에서 얼마나 효율적으로 시선을 관리하는지를
                                            이해하는 데 도움을 주며 해당 기술을 통해 기존 서비스와의 차별화를 이루고
                                            있습니다. 또한 웹 기반으로 서비스가 제공되므로 앱 설치 과정이 필요 없어 더
                                            많은 사용자들이 접근할 수 있습니다.
                                        </TextParagraph>
                                    </div>
                                    <div>
                                        <TitleText>참여 인원</TitleText>
                                        <div>개발 2인</div>
                                    </div>
                                    <TitleText>구현기능</TitleText>
                                    <div style={{ overflowY: 'scroll', maxHeight: '300px' }}>
                                        <SkillTitle>- Webgazer.JS를 이용한 시선 측정</SkillTitle>
                                        <SkillContent>
                                            : 사용자 눈을 감지하고, 탐지된 눈을 이등분하여 동공의 시선을 식별
                                        </SkillContent>
                                        <SkillContent>
                                            : 시선을 기록한 시간을 퍼센티지(%)로 계산하여 올바른 시선 분포(중앙 응시)를
                                            사용자에게 표시
                                        </SkillContent>
                                        <SkillContent>
                                            : 녹화 종료 버튼, 일시 정지, 그리고 캠코더를 숨기는 등의 기능을 도입하여
                                            서비스의 자율성을 향상
                                        </SkillContent>
                                        <SkillTitle>- 데이터베이스 / 서버 배포</SkillTitle>
                                        <SkillContent>
                                            : Firebase를 사용하여 데이터베이스를 구축 / NoSQL 문서 중심의 특성을 활용
                                        </SkillContent>
                                        <SkillContent>
                                            : 하위 문서의 ID는 버튼을 클릭한 년도, 월, 일, 시, 분, 초를 활용하여 겹치지
                                            않는 ID를 생성
                                        </SkillContent>

                                        <SkillContent>: Netlify를 통해 배포</SkillContent>

                                        <SkillTitle>- 마이페이지</SkillTitle>
                                        <SkillContent>
                                            : 사용자가 쉽게 접근하고 사용할 수 있도록 인터페이스 간소화
                                        </SkillContent>
                                        <SkillContent>: 개인화된 콘텐츠를 제공</SkillContent>

                                        <SkillContent>: 직관적인 네비게이션을 구성</SkillContent>
                                    </div>
                                </div>
                            </SliderContainer>
                        </div>
                    )}
                    {contentNum === 3 && (
                        <div>
                            <SliderContainer>
                                <ImageContainer>
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            <ImageSlider src={'images/gahter1.gif'} />
                                            <ImageSlider src={'images/gahter3.gif'} />
                                            <ImageSlider src={'images/gahter2.gif'} />
                                        </Slider>
                                    </div>
                                    <div
                                        style={{
                                            marginTop: '15%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <SliderContainer style={{ marginBottom: 20 }}>
                                            <TitleContainer>GITHUB</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <div>
                                                <a
                                                    href="https://github.com/Kimyeongsan/LuckWasteSorting?tab=readme-ov-file#luckwastesorting"
                                                    target="_blank"
                                                >
                                                    게더투모로 깃허브 🐈‍⬛
                                                </a>
                                            </div>
                                        </SliderContainer>

                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer>STACK</TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="React-Native" colorset={'#61DAFB'} />
                                            <SkillProjectButton content="Camera-Tflite" colorset={'#E64E3D'} />
                                        </SliderContainer>
                                        <SliderContainer style={{ bottom: 0 }}>
                                            <TitleContainer style={{ color: 'white', border: '0px' }}>
                                                STACK
                                            </TitleContainer>
                                            <div style={{ width: '10px' }} />

                                            <SkillProjectButton content="Style-Component" colorset={'#DDA2DB'} />
                                        </SliderContainer>
                                        <SliderContainer style={{ marginTop: 15 }}>
                                            <TitleContainer>LINK</TitleContainer>
                                            <div style={{ width: '10px' }} />
                                            <a
                                                href="https://drive.google.com/file/d/1DdpH4EpHb7NmmSm6PzLEgYI5NREuWKy_/view?usp=sharing"
                                                target="_blank"
                                            >
                                                프로젝트 기획서 🔗
                                            </a>
                                        </SliderContainer>
                                    </div>
                                </ImageContainer>
                                <div
                                    style={{
                                        marginLeft: '4%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-evenly',

                                        height: window.innerHeight * 0.86,
                                    }}
                                >
                                    <div>
                                        <TitleText>프로젝트 이름</TitleText>
                                        <div>재활용 가이드, 내일을 모으다</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 기간</TitleText>
                                        <div>2022.03 - 2022.06</div>
                                    </div>
                                    <div>
                                        <TitleText>프로젝트 소개</TitleText>
                                        <TextParagraph>
                                            '내일을 모으다' 어플리케이션은 mz세대를 겨냥한 개인 맞춤형 환경 보호 실천
                                            컨텐츠로, 개인의 운세를 제공함과 동시에 환경 보호 또한 꾸준히 실천할 수
                                            있다는 특장점을 갖추고 있습니다. 재활용 방법과 관련된 기존
                                            어플리케이션들과는 다르게, '내일을 모으다'는 이목이 집중되고 있는 재활용과
                                            운세 컨텐츠와의 신선한 결합으로 이용자들의 관심을 끌 수 있다는 점에서 시장
                                            경쟁력을 갖추고 있습니다.
                                        </TextParagraph>
                                    </div>
                                    <div>
                                        <TitleText>참여 인원</TitleText>
                                        <div>개발 3인</div>
                                    </div>
                                    <TitleText>구현기능</TitleText>
                                    <div style={{ overflowY: 'scroll', maxHeight: '300px' }}>
                                        <SkillTitle>- 순차 탐색 알고리즘을 활용한 운세 기능 구현</SkillTitle>
                                        <SkillContent>
                                            : JavaScript를 사용하여 순차 탐색 알고리즘을 이용한 운세 서비스 개발
                                        </SkillContent>

                                        <SkillTitle>- Firebase Authentication 로그인 기능 구현</SkillTitle>
                                        <SkillContent>
                                            : OAuth 2.0 프로토콜을 활용하여 사용자 인증과 권한 부여
                                        </SkillContent>
                                        <SkillContent>
                                            : Firebase의 실시간 데이터베이스를 활용하여 사용자 정보를 안정적으로 관리
                                        </SkillContent>

                                        <SkillTitle>- UI/UX 디자인 구성:</SkillTitle>
                                        <SkillContent>
                                            : React와 CSS를 이용하여 사용자 중심의 UI/UX를 디자인
                                        </SkillContent>
                                        <SkillContent>: Styled Components를 활용하여 디자인 시스템 구축</SkillContent>

                                        <SkillContent>
                                            : UI/UX 디자인과 개발 과정을 통합하여 사용자 중심의 웹 애플리케이션을 제작
                                        </SkillContent>
                                    </div>
                                </div>
                            </SliderContainer>
                        </div>
                    )}
                    {contentNum === 4 && (
                        <SliderContainer>
                            <div>
                                <SliderContainer>
                                    <ImageContainer>
                                        <div className="slider-container">
                                            <Slider {...settings}>
                                                <ImageSlider src={'images/study2.jpg'} />
                                                <ImageSlider src={'images/study3.jpg'} />
                                            </Slider>
                                        </div>
                                        <div
                                            style={{
                                                marginTop: '15%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        ></div>
                                    </ImageContainer>
                                    <div
                                        style={{
                                            marginLeft: '4%',
                                            display: 'flex',

                                            height: window.innerHeight * 0.86,
                                        }}
                                    >
                                        <div style={{ width: '1000px' }}>
                                            <TitleText>진행 스터디</TitleText>
                                            <SkillTitle>- JAVA SCRIPT 스터디</SkillTitle>

                                            <SkillContent>
                                                {' '}
                                                <a
                                                    href="https://github.com/Jungle-JavaScript-Study/deep-dive"
                                                    target="_blank"
                                                >
                                                    : JS 스터디 레파지토리 🔗
                                                </a>
                                            </SkillContent>

                                            <SkillContent>: 모던 자바스크립트 딥다이브 책으로 스터디 진행</SkillContent>
                                            <SkillContent>: 1회독 진행 후, 2회독 진행 예정</SkillContent>

                                            <SkillTitle>- PINTOS (OS 프로젝트)</SkillTitle>

                                            <SkillContent>
                                                {' '}
                                                <a href="https://github.com/PintOS-team04/pintos-kaist" target="_blank">
                                                    : PINTOS 최종 버전🔗
                                                </a>
                                            </SkillContent>
                                            <SkillContent>
                                                : PintOS의 코드를 직접 수정해가며 진행하는 C언어 프로젝트
                                            </SkillContent>

                                            <SkillContent>: PROJECT 1 - THREADS 1주 구현</SkillContent>
                                            <SkillContent>: PROJECT 2 - USER PROGRAMS</SkillContent>
                                            <SkillContent>: PROJECT 3 - VIRTUAL MEMORY</SkillContent>
                                            <SkillContent>: PROJECT 4 - FILE SYSTEM</SkillContent>

                                            <SkillTitle>- 운영체제 스터디</SkillTitle>

                                            <SkillContent>
                                                <a
                                                    href="https://nonchalant-stretch-d7e.notion.site/dcdb90ee5b45446e85aacc8f28d13acf?pvs=4"
                                                    target="_blank"
                                                >
                                                    : 운영체제 스터디 🔗
                                                </a>
                                            </SkillContent>
                                            <SkillContent>: KOSW 강의를 기반으로 스터디 진행</SkillContent>

                                            <SkillContent>: 컴퓨터시스템의 구조 / 프로세스 관리 </SkillContent>
                                            <SkillContent>: cpu 스케쥴링 / 병행제어</SkillContent>
                                            <SkillContent>: 메모리관리</SkillContent>

                                            <SkillTitle>- 네트워크 스터디</SkillTitle>

                                            <SkillContent>
                                                <a
                                                    href="https://nonchalant-stretch-d7e.notion.site/8a9f4f019ba14812a49eb4ddb4d2aaf7"
                                                    target="_blank"
                                                >
                                                    : 네트워크 스터디 🔗
                                                </a>
                                            </SkillContent>
                                            <SkillContent>: KOSW 강의를 기반으로 스터디 진행</SkillContent>

                                            <SkillContent>: 전송계층 / 네트워크 계층 </SkillContent>
                                            <SkillContent>: 링크계층 </SkillContent>
                                            <SkillContent>: 무선 및 모바일 네트워크</SkillContent>
                                            <SkillContent>: 멀티미디어 네트워크</SkillContent>
                                            <SkillContent>: 네트워크 보안</SkillContent>
                                        </div>
                                    </div>
                                </SliderContainer>
                            </div>
                        </SliderContainer>
                    )}
                </Rodal>
            </PC>

            {[...Array(5)].map((_, index) => (
                <button
                    key={index}
                    onClick={() => {
                        setVisable(!visable);
                        setContentNum(index);
                    }}
                    style={{
                        border: 'none',
                        outline: 'none',
                        background: 'none',
                        filter: hoveredButton === index ? 'none' : 'grayscale(100%)',
                        marginRight: index === 4 ? '0.5%' : '0',
                    }}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                >
                    <SelectView key={index} scrollX={scrollX} indexNum={index} />
                </button>
            ))}
        </Container>
    );
}

export default Project;
